import type { AxiosError } from 'axios';
import axiosInstance from '../lib/axios';
import type { CreateIntegrationClientInput, IntegrationClient } from '../types';
import type { ApiResponse } from './api';

export type UpdateIntegrationClientInput = Partial<CreateIntegrationClientInput>;

type ApiErrorBody = { message?: string; error?: string };

const errorMessage = (error: unknown, fallback: string): string => {
  const axiosError = error as AxiosError<ApiErrorBody>;
  return axiosError.response?.data?.message || axiosError.response?.data?.error || fallback;
};

export const updateIntegrationClient = async (
  clientPublicId: string,
  input: UpdateIntegrationClientInput
): Promise<ApiResponse<IntegrationClient>> => {
  try {
    const response = await axiosInstance.patch(`/v1/integration-clients/${clientPublicId}`, input);

    return { success: true, data: response.data.data || response.data };
  } catch (error) {
    console.error('Update integration client error:', error);
    return { success: false, error: errorMessage(error, 'Failed to update integration client') };
  }
};

export const deleteIntegrationClient = async (
  clientPublicId: string
): Promise<ApiResponse<void>> => {
  try {
    await axiosInstance.delete(`/v1/integration-clients/${clientPublicId}`);

    return { success: true };
  } catch (error) {
    console.error('Delete integration client error:', error);
    return { success: false, error: errorMessage(error, 'Failed to delete integration client') };
  }
};
